var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "linkedin"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    className: "cls-1",
    d: "M442.18,0H69.82A69.82,69.82,0,0,0,0,69.82V442.18A69.82,69.82,0,0,0,69.82,512H442.18A69.82,69.82,0,0,0,512,442.18V69.82A69.82,69.82,0,0,0,442.18,0ZM174.55,405.18A10.8,10.8,0,0,1,163.78,416h-46a10.78,10.78,0,0,1-10.82-10.76V212.36a10.82,10.82,0,0,1,10.82-10.82h46a10.83,10.83,0,0,1,10.8,10.82ZM140.74,183.27a43.64,43.64,0,1,1,43.64-43.63A43.63,43.63,0,0,1,140.74,183.27ZM415,405.93a9.91,9.91,0,0,1-9.89,9.95H355.55A9.92,9.92,0,0,1,345.6,406V315.61c0-13.5,4-59.12-35.29-59.12-30.4,0-36.59,31.22-37.82,45.24V406.05a9.94,9.94,0,0,1-9.8,9.95H214.92a9.92,9.92,0,0,1-9.92-9.92V211.52a9.93,9.93,0,0,1,9.89-10h47.8a10,10,0,0,1,9.95,10v16.81c11.29-17,28-30,63.71-30,79.07,0,78.54,73.83,78.54,114.39Z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinLogo);
export default __webpack_public_path__ + "static/media/linkedin-logo.89af0b1685935c93ae056120e7e2cfb9.svg";
export { ForwardRef as ReactComponent };